/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, createContext } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, createUserProfileDocument } from '../firebase';

export const UserContext = createContext();
export const AuthLoadingContext = createContext(true);

const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    let unsubscribeFromAuth = null;

    async function FetchUsers() {
        try {
            unsubscribeFromAuth = onAuthStateChanged(auth, async (userAuth) => {
                if (userAuth) {
                    await createUserProfileDocument(userAuth);
                }
                setUser(userAuth);
                setLoading(false);
            });
        } catch (error) {
            console.log('Error in UserProvider', error.message);
            setLoading(false);
        }
    }
    useEffect(() => {
        FetchUsers();
        return () => {
            unsubscribeFromAuth();
        };
    }, []);

    return (
        <AuthLoadingContext.Provider value={loading}>
            <UserContext.Provider value={user}>{children}</UserContext.Provider>
        </AuthLoadingContext.Provider>
    );
};

export default UserProvider;
